export default __webpack_public_path__ + "static/ecosystems-f360289b1a97b00eac1621d43d61c3e9.jpg";